
















































































































































import { Component, Ref, Vue, Watch } from "vue-property-decorator";
import api from "@/api/index";
import PagedTableView from "@/components/PagedTableView/index.vue";
import AbSelect from "@/components/AbSelect/index.vue";
import moment from "moment";
import {
  ExternalMonthlyPlanDto,
  ExternalProjectIntentionDto,
  InternalMonthlySummarizeDto,
  InternalProjectSummaryReportDto,
  AuditFlowScope,
} from "@/api/appService";
import AgileAuditTag from "@/components/AgileAuditTag/index.vue";
import SendNotify from "@/components/SendNotify/index.vue";

@Component({
  name: "externalMonthPlanList",
  components: {
    SendNotify,
    PagedTableView,
    AbSelect,
    AgileAuditTag,
  },
  filters: {
    formatDate(year: any, month: any) {
      if (month < 10) {
        month = "0" + month;
      }
      return year + "-" + month;
    },
  },
})
export default class externalMonthPlanList extends Vue {
  @Ref() showNotify!: SendNotify;
  private editLinkId = 0;
  queryForm: any = {
    year: undefined,
    displayName: "",
  };

  get getNotifyApiUrl() {
    return api.internalProjectSummaryReports.sendNotify;
  }

  created() {
    if (this.$route.query.projectId) {
      this.queryForm.projectId = Number(this.$route.query.projectId);
    }
  }

  // 发送通知
  handleShowNotify() {
    (this.showNotify as any).isShowNotify = true;
  }

  fetchData(params: any) {
    return api.internalProjectSummaryReports.getAll(params);
  }

  // 操作按钮
  handleMenu($row: any) {
    switch ($row.type) {
      case "detail":
        this.handleDetail($row.item);
        break;

      case "edit":
        this.handleEdit($row.index, $row.item);
        break;

      case "delete":
        this.handleDelete($row.index, $row.item);
        break;

      case "startAudit":
        this.handleStartAudit($row.index, $row.item);
        break;

      case "auditFlow":
        this.handleAuditFlow($row.index, $row.item);
        break;
    }
  }

  handleCreate() {
    this.$router.push({
      name: "internalProjectSummaryReportsCreate",
    });
  }

  handleEdit(index: number, row: any) {
    this.$router.push({
      name: "internalProjectSummaryReportsEdit",
      params: {
        id: row.id,
      },
    });
  }

  handleDetail(row: any) {
    this.$router.push({
      name: "internalProjectSummaryReportsDetail",
      params: {
        id: row.id,
      },
    });
  }

  //  提交审核
  async handleStartAudit(index: number, row: ExternalProjectIntentionDto) {
    // await api.internalProjectSummaryReports
    //   .startAudit({body: {id: row.id}})
    //   .then(res => {
    //     this.$message.success("已提交");
    //   });
  }

  // 删除
  async handleDelete(index: number, row: InternalProjectSummaryReportDto) {
    this.$confirm("你确定删除吗?", "提示").then(async () => {
      await api.internalProjectSummaryReports
        .delete({ id: row.id })
        .then((res) => {
          this.$message({
            type: "success",
            message: "删除成功!",
          });
        });
    });
  }

  handleAuditFlow(index: number, row: any) {
    this.$router.push({
      name: "auditFlowDetail",
      params: {
        hostType: AuditFlowScope.InternalProjectSummaryReport,
        hostId: row.id,
        auditFlowId: row.auditFlowId,
      },
    });
  }
}
